import {toUrl} from "@/utils/textUtilities";

export function transform(model) {
    return {
        company: model.company,
        website_urls: [
            toUrl(model.website_url)
        ],
        cookie_purpose: model.cookie_purpose,
        used_third_party_cookies: model.used_third_party_cookies,
        cookie_notice_shown: model.cookie_notice_shown || model.cookie_notice_use_termshub || false,
    };
}

export function retransform(params) {
    return {
        ...params,
        website_url: params.website_urls.join(",")
    }
}
